const BASE_URL = process.env.REACT_APP_API_URL ?? '';

export const parseChessResultsTournament = async (id) => {
  const response = await fetch(`${BASE_URL}/api/parsing/chess-results/parse/${id}`);
  if (!response.ok) {
    const errData = await response.json().catch(() => ({}));
    throw new Error(errData.message || 'Error al procesar el torneo.');
  }
  return response.json();
};

export const recognizePlayer = async (nombre) => {
  const url = new URL('/api/parsing/players/recognize', BASE_URL || window.location.origin);
  url.searchParams.set('nombre', nombre);
  const response = await fetch(url.href);
  if (!response.ok) {
    const errData = await response.json().catch(() => ({}));
    throw new Error(errData.message || 'Error al reconocer el jugador.');
  }
  return response.json();
};

export const quickRegisterPlayer = async (playerData) => {
  const response = await fetch(`${BASE_URL}/api/parsing/players/quick-register`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(playerData),
  });
  if (!response.ok) {
    const errData = await response.json().catch(() => ({}));
    throw new Error(errData.message || 'Error al registrar al jugador.');
  }
  return response.json();
};

export const importChessResultsTournament = async (importData) => {
  const response = await fetch(`${BASE_URL}/api/parsing/chess-results/import`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(importData),
  });
  if (!response.ok) {
    const errData = await response.json().catch(() => ({}));
    throw new Error(errData.message || 'Error al importar el torneo.');
  }
  return response.json();
};

/**
 * Sube los 3 archivos de SwissPerfect al parser y retorna el JSON del torneo (SPTournament).
 * @param {File} iniFile - Archivo .ini
 * @param {File} trnFile - Archivo .trn (DBF de jugadores)
 * @param {File} scoFile - Archivo .sco (DBF de resultados)
 */
export const parseSwissPerfectTournament = async (iniFile, trnFile, scoFile) => {
  const formData = new FormData();
  formData.append('ini', iniFile);
  formData.append('trn', trnFile);
  formData.append('sco', scoFile);

  const response = await fetch(`${BASE_URL}/api/parsing/swissperfect/parse`, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    const errData = await response.json().catch(() => ({}));
    throw new Error(errData.message || 'Error al parsear los archivos de Swiss Perfect.');
  }
  return response.json();
};

/**
 * Envía los datos del torneo de SwissPerfect y el mapeo de jugadores al backend
 * para crear el torneo en la base de datos.
 * @param {{ name, system, rounds, playerMappings }} importData
 */
export const importSwissPerfectTournament = async (importData) => {
  const response = await fetch(`${BASE_URL}/api/parsing/swissperfect/import`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(importData),
  });
  if (!response.ok) {
    const errData = await response.json().catch(() => ({}));
    throw new Error(errData.message || 'Error al importar el torneo de Swiss Perfect.');
  }
  return response.json();
};


